import styled from 'styled-components/macro'

import { Container } from 'components/container'
import { mq } from 'styles/mq'

export const StyledFooter = styled.footer`
  margin: 5rem 0 3rem;
  padding: 3rem 0;
  border-top: 1px solid rgba(31, 33, 36, 0.3);

  ${mq.medium} {
    padding: 6rem 0;
  }

  ${Container} {
    display: flex;
    flex-direction: column;

    ${mq.large} {
      flex-direction: row;
      gap: 8%;
    }

    > div {
      flex-grow: 2;

      ${mq.large} {
        width: 0;
      }

      &:last-child {
        flex-grow: 1;
      }
    }
  }

  ul {
    list-style: none;
    padding: 0;
  }

  a {
    color: inherit;

    &:not(:hover) {
      text-decoration: underline;
    }
  }
`

export const Title = styled.h2`
  margin: 2.4rem 0 1.4rem;
  font-size: 2.4rem;
  text-transform: uppercase;
  font-family: 'Skolar Sans Condensed', sans-serif;
  font-weight: 700;
`

export const Logos = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 3rem;
  max-width: 50rem;
  padding-top: 3rem;
  margin-top: 3rem;
  border-top: 1px solid rgba(31, 33, 36, 0.3);

  svg {
    height: 15rem;
  }
`
